export let DiscountExpirationType = /*#__PURE__*/function (DiscountExpirationType) {
  DiscountExpirationType["Days"] = "days";
  DiscountExpirationType["Date"] = "date";
  return DiscountExpirationType;
}({});
export class LimitedTimeDiscountOfferModel {
  static fromDTO(dto) {
    return new LimitedTimeDiscountOfferModel(dto.expiration);
  }
  constructor(expiration) {
    this.expiration = expiration;
  }
  Expiration() {
    return this.expiration;
  }
  DiscountExpirationType() {
    return this.expiration.type;
  }
  ExpirationDays() {
    return this.expiration.type === DiscountExpirationType.Days ? this.expiration.days : undefined;
  }
  ExpirationDate() {
    return this.expiration.date || undefined;
  }
  IsWithin() {
    return this.expiration.type === DiscountExpirationType.Days;
  }
  IsUntil() {
    return this.expiration.type === DiscountExpirationType.Date;
  }
  setExpiration(expiration) {
    return new LimitedTimeDiscountOfferModel(expiration);
  }
  setExpirationDays(days) {
    return new LimitedTimeDiscountOfferModel({
      type: DiscountExpirationType.Days,
      days
    });
  }
  setExpirationDate(date) {
    return new LimitedTimeDiscountOfferModel({
      type: DiscountExpirationType.Date,
      date
    });
  }
}